<template>
  <article class="page-projects-list-block">
    <!-- Image -->
    <div class="page-projects-list-block__image">
      <NuxtLink
        :to="
          localePath({
            name: routeName,
            params: { slug: props.project.slug },
          })
        "
        :data-hoverable="$t('cursor.read')"
      >
        <WidgetPicture
          :image="{
            custom: props.project.cover?.[0],
          }"
          :lazyLoad="true"
          :alt="props.project.cover?.[0]?.title"
        />
      </NuxtLink>
    </div>
    <div class="page-projects-list-block__content m-top-16px">
      <!-- Header -->
      <header class="m-bottom-24px">
        <NuxtLink
          :to="
            localePath({
              name: routeName,
              params: { slug: props.project.slug },
            })
          "
          :data-hoverable="$t('cursor.read')"
        >
          <p
            class="text-uppercase text-s"
            v-if="props.project.projectType.length"
          >
            {{ props.project.projectType.join(', ') }}
          </p>
          <h2
            class="title"
            :class="{
              'm-top-8px': props.project?.projectType?.length,
            }"
          >
            {{ props.project.title }}
          </h2>
        </NuxtLink>
      </header>
      <!--Link 
      <WidgetLinkMainUnderline
        :link="{
          title: $t('pages.projects.readProjects'),
          route: {
            name: routeName,
            params: { slug: props.project.slug },
          },
        }"
      /> -->
    </div>
  </article>
</template>

<script>
export default {
  name: 'PagesNewsListBlock',
}
</script>

<script setup>
const props = defineProps({
  project: Object,
})

const routeName = computed(() => {
  return props.project.__typename.includes('bespoke')
    ? 'bespoke-slug'
    : 'projects-slug'
})
</script>

<style lang="scss">
@import './style.scss';
</style>
